import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { Skeleton } from "@/components/ui/skeleton";

export interface LoadingStateProps {
  threshold?: number;
}

export function LoadingState({ threshold = 600 }: LoadingStateProps) {
  const [showSpinner, setShowSpinner] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setShowSpinner(true), threshold);
    return () => clearTimeout(t);
  }, [threshold]);
  if (showSpinner) {
    return (
      <div role="status" aria-live="polite" className="flex items-center justify-center p-6">
        <Loader2 className="size-6 animate-spin text-muted-foreground" />
      </div>
    );
  }
  return (
    <div role="status" aria-live="polite" data-testid="loading-skeleton" className="flex flex-col gap-2 p-6">
      <Skeleton className="h-6 w-1/3" />
      <Skeleton className="h-32 w-full" />
      <Skeleton className="h-32 w-full" />
    </div>
  );
}
